export const alphanumericalNameWithUnderscore = /^[a-zA-Z0-9_]+$/;
export const alphanumericalNameWithDash = /^[a-zA-Z0-9-_ ]+$/;
export const letters = /^[a-zA-Z]+$/;
export const commaOrSpaceOrQuote = /[\s,"]/;
export const unprintableChars = /[^ -~]+/g;
export const scientificNotationRegExp = /[-+]?\d+(?:\.\d+)?[eE][-+]?\d+/;
// one or more digit(s) optionally followed by a dot and zero or more digits
// optionally started with negative sign
export const digitsOnlyRegExp = /(-?\d+\.?\d*)/m;
